import { createFileRoute } from "@tanstack/react-router";
import { TasksPage } from "./-pages/TasksPage";
import { TaskStats } from "./-pages/TaskStats";
import { trpc, queryClient } from "~/utils/trpc";
import { useQuery } from "@tanstack/react-query";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/tasks/statistics")({
  component: RouteComponent,
  loader: async () => {
    const config = await queryClient.fetchQuery(trpc.tasksConfig.getEffective.queryOptions());
    return { config };
  },
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  const { config } = Route.useLoaderData();
  const stats = useQuery(trpc.tasks.stats.queryOptions());
  useBreadCrumbs([{ title: "Tasks", link: `/${datasetSlug}/tasks` }]);

  return (
    <TasksPage config={config} datasetSlug={datasetSlug}>
      <TaskStats stats={stats} config={config} />
    </TasksPage>
  );
}
